// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5b7dc91f-168":"412b60dcc0c7eed4d11f","5b7dc91f-452":"1dc0a5ec580fe1797cca","5b7dc91f-379":"050af4959c9c48566ba4","5b7dc91f-83":"8714941575ac6daf980f"}[chunkId] + ".js";
};